<script>
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	
</script>

<footer id="footer">
  <p>
    <a href="#about" on:click|preventDefault={() => dispatch("about")}>About Typepost</a>  |  <a href="https://www.paypal.com/donate?hosted_button_id=SQCSLTW9XHHUJ" target="_blank">Buy me a drink?</a>
  </p>
</footer>

<style>
  #footer {
    font-size: 0.8rem;
    text-align: center;
  }

</style>